<template>
    <div>
        <v-tabs vertical class="overflow-fix">
            <div v-if="showCompany">
                <p class="pa-1 primary rounded white--text text-center d-inline-block" style="width:100%;">{{ $t('companyLabel') }}: <span
                        class="font-weight-bold">{{ this.company.name1 }}</span></p>
            </div>
            <v-tab class="d-flex justify-start text-wrap text-left">
                {{ $t("userProfileLabel") }}
            </v-tab>
            <v-tab class="d-flex justify-start text-wrap text-left">
                {{ $t("listOfOrdersLabel") }}
            </v-tab>
            <v-tab class="d-flex justify-start text-wrap text-left">
                {{ $t("listOfProductsLabel") }}
            </v-tab>

            <v-tab-item>
                <v-card class="pl-9" flat>
                    <v-card-text class="pa-0">
                        <div class="d-flex mb-5">
                            <div class="black--text text-h5">{{ $t("userProfileLabel") }}</div>
                        </div>
                    </v-card-text>
                    <UserProfile v-bind:userId="parseInt(this.$route.params.userId)" />
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card class="pl-9" flat>
                    <v-card-text class="pa-0">
                        <div class="d-flex mb-5 ">
                            <div class="black--text text-h5 text-center">{{ $t("listOfOrdersLabel") }}</div>
                        </div>
                    </v-card-text>

                    <OrdersTable v-bind:companyId="0" v-bind:userId="parseInt(this.$route.params.userId)"
                        v-bind:canEdit="true" v-bind:getByUser="true" v-bind:getByCompany="false" />

                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card class="pl-9" flat>
                    <v-card-text class="pa-0">
                        <div class="d-flex mb-5 ">
                            <div class="black--text text-h5 text-center">{{ $t("listOfProductsLabel") }}</div>
                        </div>
                    </v-card-text>
                    <ProductConfigurationsTable v-bind:companyId="parseInt(0)"
                        v-bind:userId="parseInt(this.$route.params.userId)" v-bind:canAddNew="false"
                        v-bind:canEdit="true" v-bind:getByUser="true" v-bind:getByCompany="false" />
                </v-card>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
    import UserProfile from '../../components/UserProfile';
    import ProductConfigurationsTable from '../../components/ProductConfigurationsTable';
    import OrdersTable from '../../components/OrdersTable';

    export default {
        components: {
            UserProfile,
            ProductConfigurationsTable,
            OrdersTable
        },
        data() {
            return {
                company: '',
                showCompany: false,
            }
        },
        methods: {
            canShowCompany() {
                if(this.$route.fullPath.includes('sale-partnerships')){
                    this.showCompany = true
                }
            },
            getCompany() {
                var companyId = this.$route.params.companyId;
                this.axios
                    .get("api/company/getbyid/", {
                        params: {
                            id: companyId,
                        },
                    })
                    .then((response) => {
                        this.company = response.data;
                    })
                    .catch((error) => {});
            },
        },
        mounted() {
            this.getCompany()
            this.canShowCompany()
        },
    }
</script>